import React from 'react';
import EATApp from './EATApp';
import AffiliatesDashboard from './AffiliatesDashboard';

export default function App() {
  const isAdmin = window.location.pathname.startsWith('/admin');
  if (isAdmin) return <AffiliatesDashboard />;
  return <EATApp />;
}
